export const LF_TOGGLE_SHOW_LINES = 'LF_TOGGLE_SHOW_LINES';
export const LF_TOGGLE_SHOW_BACKGROUND = 'LF_TOGGLE_SHOW_BACKGROUND';
export const LF_TOGGLE_SHOW_CONTROLS = 'LF_TOGGLE_SHOW_CONTROLS';
export const LF_TOGGLE_DRAW_IN_PROGRESS = 'LF_TOGGLE_DRAW_IN_PROGRESS';
export const LF_TOGGLE_DRAW_FINISHED = 'LF_TOGGLE_DRAW_FINISHED';
export const LF_RESET_PATH_INDEX = 'LF_RESET_PATH_INDEX';
export const LF_SET_NEXT_PATH_INDEX = 'LF_SET_NEXT_PATH_INDEX';
export const LF_ENABLE_CONTINUOUS_DRAW = 'LF_ENABLE_CONTINUOUS_DRAW';
export const LF_CLEAR_ALL_PATHS = 'LF_CLEAR_ALL_PATHS';

export const LF_AUDIO_DOWNLOAD_REQUEST = 'LF_AUDIO_DOWNLOAD_REQUEST';
export const LF_AUDIO_DOWNLOAD_RESPONSE = 'LF_AUDIO_DOWNLOAD_RESPONSE';
export const LF_SHOW_START_BUTTON = 'LF_SHOW_START_BUTTON';
export const LF_SET_AUDIO = 'LF_SET_AUDIO';